import { getAcceptLanguageHeader } from '../i18n';

async function orderJobsRequest(token, path, options = {}) {
  const response = await fetch(path, {
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      Authorization: `Bearer ${token}`,
      'Accept-Language': getAcceptLanguageHeader(),
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok || payload?.success === false) {
    throw new Error(payload?.error || 'Ошибка запроса');
  }

  return payload;
}

export function fetchDeferredOrders(token, hours = 12) {
  return orderJobsRequest(
    token,
    `/api/v1/order-jobs/deferred?hours=${encodeURIComponent(hours)}`,
  );
}

export function accelerateDeferredOrders(token, hours = 12) {
  return orderJobsRequest(token, '/api/v1/order-jobs/deferred/accelerate', {
    method: 'POST',
    body: JSON.stringify({ hours }),
  });
}

export function fetchSubmittedOrders(token, hours = 12) {
  return orderJobsRequest(
    token,
    `/api/v1/order-jobs/submitted?hours=${encodeURIComponent(hours)}`,
  );
}

export function checkSubmittedOrderNow(token, orderId) {
  return orderJobsRequest(token, `/api/v1/order-jobs/${orderId}/check-now`, {
    method: 'POST',
  });
}
